import { useEffect as e } from "react";
//#region src/hooks/useEffectOnce.ts
var t = (t) => {
	e(t, []);
};
//#endregion
export { t as default };

//# sourceMappingURL=useEffectOnce.js.map